import CreateEvaluationDialogContainer from './CreateEvaluationDialogContainer';

export default CreateEvaluationDialogContainer;
